import { ADDITIONAL_INFORMATION_TYPES } from '@savgroup-front-common/types';

import { NeededInformation } from '../../AdditionalInformation.context';
import { buildInputName } from '../../AdditionalInformationInput.helpers';

export const verifyThatShouldRecognizeSerialNumber = ({
  neededInformationItems,
  name,
  prefixFormName,
  claimIds,
  getValues,
}: {
  neededInformationItems: NeededInformation[];
  name: string;
  prefixFormName?: string;
  claimIds?: string[];
  getValues?: (name: string) => any;
}) => {
  return neededInformationItems
    .filter((neededInformationItem) => {
      const targetName = buildInputName({
        prefixFormName,
        name: neededInformationItem.internalId,
      });

      return targetName !== name;
    })
    .some((neededInformationItem) => {
      return claimIds?.every((claimId) => {
        const targetName = buildInputName({
          prefixFormName,
          name: neededInformationItem.internalId,
        });

        const targetValue = getValues?.(targetName);

        return (
          claimId &&
          !targetValue &&
          neededInformationItem.type ===
            ADDITIONAL_INFORMATION_TYPES.SERIAL_NUMBER &&
          neededInformationItem.claimIds?.includes(claimId) &&
          neededInformationItem.claimIds.length > 0
        );
      });
    });
};
